//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  
  
  export class DynamicDataSetListModel extends ModelBase {
      static readonly $typeName = 'DynamicDataSetListModel';
      public hasDraft: boolean;
      public key: string;
      public dataSetIdentifier: string;
      public dataSetVersion: number;
      public name: string;
      public status: string;
      public releasedDate: Date;
      
  }



// WEBPACK FOOTER //
// ./src/app/dynamicDataSets/models/DynamicDataSetListModel.ts